















































import { getProduct } from "../../helpers/api";
import Vue from "vue";

interface State {
  values: Array<any>;
}

export default Vue.extend({
  name: "SubscriptionInfo",
  props: ["subscriptions", "upcomingInvoice"],
  data(): State {
    return {
      values: []
    };
  },
  async mounted() {
    await this.buildSubscriptionArray();
  },
  methods: {
    async buildSubscriptionArray() {
      const arr = [];
      for (const cur of this.subscriptions) {
        for (const item of cur.items.data) {
          const resp = await getProduct(item.price.product);
          arr.push({ product: resp.data, line: item, subscription: cur });
        }
      }
      this.values = arr;
    },
    getFormattedDate(unix: number) {
      const ms = unix * 1000;
      const date = new Date(ms);
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return `${
        months[date.getMonth()]
      } ${date.getDate()}, ${date.getFullYear()}`;
    }
  },
  watch: {
    subscriptions: function() {
      this.buildSubscriptionArray();
    }
  }
});
